import axios from 'axios';
import {checkErrors} from './errors';

export const LOADMEDIAS_REQUESTED = 'medias/LOADMEDIAS_REQUESTED';
export const LOADMEDIAS_FINISHED = 'medias/LOADMEDIAS_FINISHED';
export const SETMEDIAS = 'medias/SETMEDIAS';

export const ADDMEDIA_REQUESTED = 'medias/ADDMEDIA_REQUESTED';
export const ADDMEDIA_FINISHED = 'medias/ADDMEDIA_FINISHED';

export const EDITMEDIA_REQUESTED = 'medias/EDITMEDIA_REQUESTED';
export const EDITMEDIA_FINISHED = 'medias/EDITMEDIA_FINISHED';

export const REMOVEMEDIA_REQUESTED = 'medias/REMOVEMEDIA_REQUESTED';
export const REMOVEMEDIA = 'medias/REMOVEMEDIA';
export const REMOVEMEDIA_FINISHED = 'medias/REMOVEMEDIA_FINISHED';

export const LOADMEDIA_REQUESTED = 'medias/LOADMEDIA_REQUESTED';
export const LOADMEDIA_FINISHED = 'medias/LOADMEDIA_FINISHED';

export const ADDMEDIA_UPLOADINGPERCENT = 'medias/ADDMEDIA_UPLOADINGPERCENT';

const initialState = {
  medias: [],
  total: 0,
  limit: 1000,
  skip: 0,
  isLoadingMedias: false,
  isAddingMedia: false,
  isEditingMedia: false,
  isRemovingMedia: false,
  isLoadingMedia: false,
  percentUploaded: 0
};

export default (state = initialState, action) => {
  switch (action.type) {
  case LOADMEDIAS_REQUESTED:
    return {
      ...state,
      isLoadingMedias: true
    };

  case LOADMEDIAS_FINISHED:
    return {
      ...state,
      isLoadingMedias: false
    };

  case SETMEDIAS:
    
    return {
      ...state,
      medias: action.medias
    };
  
  case ADDMEDIA_REQUESTED:
    return {
      ...state,
      isAddingMedia: true
    };

  case ADDMEDIA_FINISHED:
    return {
      ...state,
      isAddingMedia: false
    };
  
  case EDITMEDIA_REQUESTED:
    return {
      ...state,
      isEditingMedia: true
    };

  case EDITMEDIA_FINISHED:
    return {
      ...state,
      isEditingMedia: false
    };

  case REMOVEMEDIA:
    return {
      ...state,
      medias: action.medias
    };

  case REMOVEMEDIA_REQUESTED:
    return {
      ...state,
      isRemovingMedia: true,
    };

  case REMOVEMEDIA_FINISHED:
    return {
      ...state,
      isRemovingMedia: false
    };
  
  case LOADMEDIA_REQUESTED:
    return {
      ...state,
      isLoadingMedia: true
    };

  case LOADMEDIA_FINISHED:
    return {
      ...state,
      isLoadingMedia: false
    };

  case ADDMEDIA_UPLOADINGPERCENT:
   return {
     ...state,
     percentUploaded: action.percentUploaded
   }
  
  default:
    return state;
  }
};


export const loadMedias = () => {
  return (dispatch, getState) => {

    const mediasState = getState().medias;

    dispatch({
      type: LOADMEDIAS_REQUESTED
    });

    axios.get(`${window.endpoint}/media?limit=${mediasState.limit}&skip=${mediasState.skip}`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      dispatch({
        type: SETMEDIAS,
        medias: response.data.media_uploaded
      });

      dispatch({
        type: LOADMEDIAS_FINISHED
      });
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const addMedia = (data, cb) => {
  return (dispatch, getState) => {

    dispatch({
      type: ADDMEDIA_REQUESTED
    });

    dispatch({
      type: ADDMEDIA_UPLOADINGPERCENT,
      percentUploaded: 0
    })

    axios.post(`${window.endpoint}/media`, data, { 
      onUploadProgress: (progressEvent) => {
        dispatch({
          type: ADDMEDIA_UPLOADINGPERCENT,
          percentUploaded: progressEvent.loaded / progressEvent.total * 100
        })
      },
      headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {
      
      dispatch({
        type: ADDMEDIA_FINISHED
      });

      if (cb instanceof Function) { cb(response); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const editMedia = (id, data, cb) => {
  return (dispatch, getState) => {
    

    dispatch({
      type: EDITMEDIA_REQUESTED
    });

    axios.put(`${window.endpoint}/media/${id}`, data, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {
      
      dispatch({
        type: EDITMEDIA_FINISHED
      });

      if (cb instanceof Function) { cb(response); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const removeMedia = (id, cb) => {
  return (dispatch, getState) => {

    const mediasState = getState().medias;

    dispatch({
      type: REMOVEMEDIA_FINISHED
    });

    axios.delete(`${window.endpoint}/media/${id}`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      dispatch({
        type: REMOVEMEDIA,
        medias: mediasState.medias.filter((media) => media.media_id !== id)
      });
      
      dispatch({
        type: REMOVEMEDIA_FINISHED
      });

      if (cb instanceof Function) { cb(response); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const loadMedia = (media_id, cb) => {
  return (dispatch, getState) => {

    dispatch({
      type: LOADMEDIAS_REQUESTED
    });

    axios.get(`${window.endpoint}/media/${media_id}`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {
      
      dispatch({
        type: LOADMEDIAS_FINISHED
      });

      if (cb instanceof Function) { cb(response); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};



// WEBPACK FOOTER //
// ./src/reducers/medias.js